function toggleGiftMessage(){
  var checkBox = document.getElementById("giftCheck");
  var giftArea = document.getElementById("giftMessageBlock");
  var body;
  if(checkBox.checked){
  	giftArea.style.display = "block";
    body = { "attributes":{'Gift Note': 'Yes'}};
    //jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[Gift Note]=Yes")
  } else {
  	giftArea.style.display = "none";
    body = {"attributes":{'Gift Note': 'No', 'Gift Message':null }};
    //jQuery.post(window.Shopify.routes.root + 'cart/update.js', "{attributes:{'Gift Note':'No','Gift Message':''}}attributes[Gift]=No")
  }
  postUpdate(body);
    
  counter();
};

function counter(){
	var inputCharCount = document.getElementById("gift-message").value.length;
	var charCountLabel = document.getElementById("giftLabel")
	var newCharCount = 160 - inputCharCount;
	charCountLabel.innerText = "Enter your gift message here: " + newCharCount + "\/" + 160;

	if (newCharCount <= 0) {
		charCountLabel.style.color = "red";
	} else {
		charCountLabel.style.color = "black";
	}

};

function giftMessageOnChange(e)
{
  var giftMessage = e.target.value;
  postUpdate({ "attributes":{'Gift Message': giftMessage.substring(0,160) }});
  //jQuery.post(window.Shopify.routes.root + 'cart/update.js', body)
  
};

function postUpdate(updateData)
{
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(updateData)});
};
document.addEventListener("DOMContentLoaded", function() {
  document.getElementById("giftCheck") == null ? null : toggleGiftMessage();
});